import { Injectable } from '@angular/core';

import { EXTERNAL_COMMUNICATION_EVENTS, ExternalCommunicationService } from '../external-communication';

export interface TopbarStateObject {
    home: {
        projectsEnabled: boolean;
        layersEnabled: boolean;
        tasksEnabled: boolean;
        optionsEnabled: boolean;
        licensingEnabled: boolean;
        helpEnabled: boolean;
        releaseNotesEnabled: boolean;
        aboutEnabled: boolean;
    };
    closeWithoutConfirm: boolean;
}
/**
 * This service manages the topbar state to send to Field Software
 */
@Injectable({ providedIn: 'root' })
export class TopbarStateService {
    constructor(private externalCommunicationService: ExternalCommunicationService) {}

    /**
     * Emits the Top Bar settings state object
     * @param {TopBarStateObject} state
     */
    setTopBarState(state: TopbarStateObject): void {
        this.externalCommunicationService.sendEvent(EXTERNAL_COMMUNICATION_EVENTS.SET_TOPBAR_STATE_REQUEST, state);
    }

    /**
     * Emits the Top Bar settings state with all properties set to true
     */
    enableAll(): void {
        this.setAllTopBarStateValues(true);
    }

    /**
     * Emits the Top Bar settings state with all properties set to false
     */
    disableAll(): void {
        this.setAllTopBarStateValues(false);
    }

    /**
     * Emits the Top Bar settings state with all properties to the same default value
     * @param {boolean} value
     */
    private setAllTopBarStateValues(value: boolean): void {
        this.setTopBarState(this.getStateObject(value));
    }

    private getStateObject(defaultValue: boolean): TopbarStateObject {
        return {
            home: {
                projectsEnabled: defaultValue,
                layersEnabled: defaultValue,
                tasksEnabled: defaultValue,
                optionsEnabled: defaultValue,
                licensingEnabled: defaultValue,
                helpEnabled: defaultValue,
                releaseNotesEnabled: defaultValue,
                aboutEnabled: defaultValue,
            },
            closeWithoutConfirm: defaultValue,
        };
    }
}
